import React, { useContext } from 'react'
import { Segment, Button, Modal, Container, Divider, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../../App/stores/RootStore';

interface DetailParams {
    RequestReviewId: string;
}

const Continue: React.FC<DetailParams> = ({ RequestReviewId }) => {
    const rootStore = useContext(RootStoreContext)
    const { ContinueToRequestReview } = rootStore.requestReviewStore;
    return (
        <Segment clearing>
            <Header>Review Confirmation</Header>
            <Divider />
            <Container>
                Welcome Back,
                would you like to continue the Review?
            </Container>

            <Divider />
            <Button
                content="Continue"
                className={'rl-btn'}
                floated='right'
                labelPosition='right'
                icon='arrow alternate circle right'
                onClick={() => ContinueToRequestReview(RequestReviewId)}
                positive
            />
        </Segment>
    )
}
export default observer(Continue);